import styled from 'styled-components';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { SUBSECTION_DATA_ATTR } from '../../constants';
export const Wrapper = styled.div.attrs({
    [SUBSECTION_DATA_ATTR]: true,
}) `
  display: flex;
  flex-direction: column;
`;
export const TitleWrapper = styled.div `
  margin: 0;
  padding: 19px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ onClick }) => !!onClick && 'pointer'};

  & span {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  @media ${Media.xsMax} {
    padding: 16px 12px;
  }
`;
export const Title = styled.span `
  ${({ theme }) => theme.typography.titleSub};
  padding: 5px 0px;
`;
export const SubTitle = styled.div `
  padding: 4px 24px;

  @media ${Media.xsMax} {
    padding: 4px 16px;
  }
`;
export const ActionsWrapper = styled.div `
  display: flex;
  gap: 8px;
`;
export const ContentWrapper = styled.div `
  position: relative;
`;
export const ContentInner = styled.div `
  padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '24px' : '0 24px 24px')};

  @media ${Media.xsMax} {
    padding: ${({ noPadding, withoutTitle }) => (noPadding ? 0 : withoutTitle ? '16px 12px' : '0 12px 16px')};
  }
`;
